<div class="container py-3">
  <div class="card">
    <div class="card-body p-5">
      <div class="row gy-4 my-5">
        <h5 class="h1 col-12 m-0">Parties</h5>
        @if (release().releaseData; as data) {
          <div class="col-12">
            <app-commercial-release-party-field label="Release-to party" [entity]="data.releaseToParty"
                                                 [editMode]="editMode()" [formatter]="refData.formatReleaseToParty"
                                                 [basicAddress]="true" [required]="true">
              <div class="d-block mb-2">
                <span class="text-secondary">Type at least 3 characters to search by name</span>
              </div>
              <app-search required [(ngModel)]="data.releaseToParty" [minCharacters]="3"
                          [searchFunction]="findReleaseToParties" [inputFormatter]="refData.formatReleaseToParty"
                          [disabled]="!!release().releaseStatus?.status"></app-search>
            </app-commercial-release-party-field>
          </div>
          <div class="col-12">
            <app-commercial-release-party-field label="Container operator" [entity]="data.containerOperator"
                                                 [editMode]="editMode()" [formatter]="refData.containerOperatorFormatter"
                                                 [richAddress]="true" [required]="true">
              <div class="d-block mb-2">
                <span class="text-secondary">Type at least 3 characters to search by name</span>
              </div>
              @if (selectedConsignment()?.crn) {
                <app-search [(ngModel)]="data.containerOperator" dataKey="name" required
                            [optionsProvider]="carriersProvider()"
                            [refreshWatch]="selectedConsignment()?.iamConnectedId || data.containerOperator?.cargoDeclarantShortName"
                            [inputFormatter]="refData.containerOperatorFormatter"
                            [disabled]="!!release().releaseStatus?.status"></app-search>
              } @else {
                <app-search [(ngModel)]="data.containerOperator" dataKey="name" required
                            [minCharacters]="3" [searchFunction]="refData.findContainerOperators"
                            [inputFormatter]="refData.containerOperatorFormatter"
                            [disabled]="!!release().releaseStatus?.status"></app-search>
              }
            </app-commercial-release-party-field>
          </div>
          <div class="col-12">
            <app-commercial-release-party-field label="Inland operator" [entity]="data.inlandOperator"
                                                 [editMode]="editMode()" [formatter]="refData.inlandOperatorFormatter"
                                                 [eanGrid]="true">
              <div class="d-block mb-2">
                <span class="text-secondary">Type at least 3 characters to search by name or EAN code</span>
              </div>
              <app-search [(ngModel)]="data.inlandOperator" [minCharacters]="3"
                          [searchFunction]="refData.findInlandOperatorsByEanCode"
                          [inputFormatter]="refData.inlandOperatorFormatter"
                          [disabled]="!!release().releaseStatus?.status"
                          (ngModelChange)="data.inlandOperator = $event" placeholder="Search by name or EAN code"
                          [resultFormatter]="refData.inlandOperatorFormatter">
              </app-search>
            </app-commercial-release-party-field>
          </div>
        }
      </div>
    </div>
  </div>
</div>
